'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _reactRedux = require('react-redux');

var _components = require('components');

var _GenericSettings = require('redux/modules/GenericSettings');

var mapStateToProps = function mapStateToProps(state) {
    return {
        all: state.genericSettings.configuration.deleteAllQuotesOnSend || false,
        selected: state.genericSettings.configuration.deleteSelectedQuotesOnSend || false,
        email: state.genericSettings.configuration.emailTraveler || false,
        send: state.genericSettings.configuration.shouldSendCommandWS || false,
        command: state.genericSettings.configuration.sendCommandWS || '',
        push: state.genericSettings.configuration.pushQuotesRefNumberWS || false,
        read: state.genericSettings.oldCFA.pushRefNum.wsdlFile.read,
        readFromDB: state.genericSettings.oldCFA.pushRefNum.wsdlFile.readFromDB,
        error: state.genericSettings.oldCFA.pushRefNum.wsdlFile.error,
        errorDB: state.genericSettings.oldCFA.pushRefNum.wsdlFile.errorDB,
        // wsdl data
        cached: state.genericSettings.oldCFA.pushRefNum.wsdlFile.cached,
        namespace: state.genericSettings.oldCFA.pushRefNum.wsdlFile.data.namespace,
        methods: state.genericSettings.oldCFA.pushRefNum.wsdlFile.data.webMethods,
        selectedMethod: state.genericSettings.oldCFA.pushRefNum.wsdlFile.webMethod,
        soapNamespace: state.genericSettings.oldCFA.pushRefNum.wsdlFile.data.soapNamespace,
        soapVersions: state.genericSettings.oldCFA.pushRefNum.wsdlFile.soapVersions,
        selectedSoapVersion: state.genericSettings.oldCFA.pushRefNum.wsdlFile.selectedSoapVersion,
        xmlRequestNamespace: state.genericSettings.oldCFA.pushRefNum.wsdlFile.data.reqNamespace,
        id: state.genericSettings.oldCFA.pushRefNum.wsdlFile.id
    };
};

var mapDispatchToProps = {
    changeProperty: _GenericSettings.changeStorageOptionProperty,
    toggleCached: _GenericSettings.toggleCached,
    toggleDeleteAll: _GenericSettings.toggleDeleteAll,
    toggleDeleteSelected: _GenericSettings.toggleDeleteSelected,
    handleEmailChange: _GenericSettings.toggleSendEmail,
    handleSendChange: _GenericSettings.toggleSendCommand,
    handleCommandChange: _GenericSettings.setSendCommand,
    handlePushChange: _GenericSettings.togglePushQuotes,
    handleWebMethodChange: _GenericSettings.webMethod,
    handleSoapVersionChange: _GenericSettings.soapVersion,
    wsdlLoading: _GenericSettings.wsdlLoading,
    wsdlReadError: _GenericSettings.wsdlReadError,
    wsdlParseError: _GenericSettings.wsdlParseError,
    wsdlInvalidError: _GenericSettings.wsdlInvalidError,
    wsdlSuccess: _GenericSettings.wsdlSuccess
};

exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(_components.ActionsOnProceed);
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/containers/ActionsOnProceed/ActionsOnProceed.js
// module id = 1620
// module chunks = 0